import { getUserMpSing } from '@/api/common'
import Vue from 'vue'
import Router from 'vue-router'
import createHelper from 'vue-router-keep-alive-helper'
import { setTitle, wxShare } from '../assets/js/tools'
import { routes } from './routes'
// import http1 from '../utils/request1'

Vue.use(Router)

const comWxPageInit = async () => {
    if (
        window.location.host.includes('localhost:') ||
        window.location.host.includes('http://10.0.18')
    )
        return
    const res = await getUserMpSing({
        url: window.location.href
    })
    if (res.code === 0) {
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.data.appId, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
            signature: res.data.signature, // 必填，签名
            jsApiList: [
                'onMenuShareAppMessage',
                'onMenuShareTimeline',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'hideMenuItems',
                'showMenuItems',
                'scanQRCode',
                'getLocation'
            ] // 必填，需要使用的JS接口列表
        })
        wx.ready(() => {
            /* wx.showMenuItems({
                menuList: [
                    'menuItem:share:appMessag',
                    'menuItem:share:timeline',
                    'menuItem:share:qq',
                    'menuItem:share:QZone',
                    'menuItem:favorite',
                ], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有 menu 项见附录3
            }); */

            wx.hideMenuItems({
                menuList: [
                    'menuItem:editTag',
                    'menuItem:delete',
                    'menuItem:copyUrl',
                    'menuItem:originPage',
                    'menuItem:readMode',
                    'menuItem:openWithQQBrowser',
                    'menuItem:openWithSafari',
                    'menuItem:share:email',
                    'menuItem:share:brand'
                ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有 menu 项见附录3
            })

            wxShare({
                title: '爬呗-一个关于攀岩情怀的平台', // 分享标题
                desc: '公众号搜索“爬呗”就能找到我', // 分享描述
                link: window.location.pathname.includes('indexDetails')
                    ? window.location.href
                    : window.location.origin, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'https://camp-1300713952.file.myqcloud.com/post/1_0f59984e38f3be34eff790a6bcf3f9bc.jpg' // 分享图标
            })
        })
    }
}

const router = new Router({
    mode: 'history',
    base: '/',
    // base:
    //     process.env.VUE_APP_ENV === 'prod' || process.env.VUE_APP_ENV === 'production'
    //         ? '/'
    //         : '/dist-test/',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        // 异步滚动操作  api：https://juejin.im/post/5b3f0860f265da0f8c0297ae
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({ x: 0, y: 1 })
            }, 0)
        })
    }
})

// 在tab栏切换时，需要留存某些tab页面，可以在replaceStay中配置这些路径
createHelper({
    Vue,
    router,
    replaceStay: ['/field', '/fieldLine', '/messageCenter', '/hall', '/personal']
})

router.beforeEach((to, from, next) => {
    next()
})

router.afterEach((to, from) => {
    comWxPageInit()
    // 更改标题
    setTitle(to.meta.title)
})
/* eslint-enable */

export default router
